import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';

import { ApiContext } from "../../context/api/apiContext";

import AppleIcon from '../../i/icons/apple.svg';
import GooglePlayIcon from '../../i/icons/google_play.svg';
import FacebookIcon from '../../i/icons/facebook.svg';
import LinkedinIcon from '../../i/icons/linkedin.svg';
import TwitterIcon from '../../i/icons/twitter.svg';
import PinterestIcon from '../../i/icons/pinterest.svg';
import MarkerIcon from '../../i/icons/marker.svg';
import EnvelopeIcon from '../../i/icons/envelope.svg';
import HeadphonesIcon from '../../i/icons/headphones.svg';

const Footer = (props) => {
	const { jsonData } = useContext(ApiContext);
	const { footer: footerData, supportedSystems } = jsonData.defaultSectionSettings;

	return (
		<footer className="footer">
			<div className="section_in footer_mod">
				<div className="footer_top">
					<div className="footer_info">
						<div className="footer_logo_w">
							<img className="footer_logo" src={footerData.logoImg} alt={footerData.logoAlt} />
						</div>
						<ul className="social_list footer_mod">
							{footerData.socialList.map(({ url, title }, index) => {
								let preparedTitle = title.toLowerCase();

								let Icon;

								switch (preparedTitle) {
									case 'facebook':
										Icon = <FacebookIcon />
										break;
									case 'linkedin':
										Icon = <LinkedinIcon />
										break;
									case 'twitter':
										Icon = <TwitterIcon />
										break;
									case 'pinterest':
										Icon = <PinterestIcon />
										break;

									default:
										break;
								}

								return (
									<li className="social_item" key={index}>
										<a className="social_link footer_mod" href={url}>
											{Icon}
										</a>
									</li>
								)
							})}
						</ul>
					</div>
					<div className="footer_nav_w">
						{footerData.menu.map((col, index) => {
							return (
								<div className="footer_nav_col" key={index}>
									<h4 className="footer_title">{col.title}</h4>
									<ul className="footer_nav_list">
										{col.links.map(({ path, title }, key) => {
											return (
												<li className="footer_nav_item" key={key}>
													<NavLink className="footer_nav_link" to={path}>{title}</NavLink>
												</li>
											)
										})}
									</ul>
								</div>
							)
						})}
						<div className="footer_nav_col lg_mod">
							<h4 className="footer_title">{footerData.contactTitle}</h4>
							<div className="footer_nav_list_w">
								<ul className="footer_nav_list">
									<li className="footer_nav_item icon_mod">
										<span className="icon_w footer_contact_mod">
											<MarkerIcon />
										</span>
										<span className="footer_nav_title">{footerData.contactAddress}</span>
									</li>
								</ul>
								<ul className="footer_nav_list">
									{footerData.contactLinks.map(({ title, url }, index) => {
										let Icon;

										if (index === 0) {
											Icon = <EnvelopeIcon />;
										} else {
											Icon = <HeadphonesIcon />;
										}

										return (
											<li className="footer_nav_item icon_2_mod" key={index}>
												<span className="icon_w footer_contact_mod">
													{Icon}
												</span>
												<a className="footer_nav_link" href={url}>{title}</a>
											</li>
										)
									})}
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="footer_bottom">
					<div className="footer_copy_w">
						<span className="footer_copy">{footerData.copyright}</span>
					</div>
					<div className="footer_app_list_w">
						<ul className="footer_app_list">
							{supportedSystems.map(({ title, url }, index) => {
								const preparedTitle = title.toLowerCase();
								let Icon;

								if (preparedTitle === 'ios') {
									Icon = <AppleIcon className="icon icon-apple size_mod" />
								} else {
									Icon = <GooglePlayIcon className="icon icon-apple size_mod" />;
								}

								return (
									<li className="footer_app_item" key={index}>
										<a className="footer_app_link" href={url}>
											<span className="icon_w footer_app">
												{Icon}
											</span>
											<span className="footer_app_link_title">{title}</span>
										</a>
									</li>
								)
							})}
						</ul>
					</div>
				</div>
			</div>
		</footer>
	)
};

export default Footer;